import React from "react";
import styles from "./Bibliothek.module.css";
import bibliothekimg from "./assets/bib.png";


const Bibliothek = () => {
    return (
        <div>
            <div
                className={styles.hero}
                style={{ backgroundImage: `url(${bibliothekimg})` }}
            />

            <div>

                <section className="wrapper wrapperContent">
                    <div className={styles.text}>
                        <h1>SCHULBIBLIOTHEK</h1>
                        <h2>Öffnungszeiten </h2>

                        <h3>Bücherausleihe:</h3>

                        <table className={styles.table}>
                            <tbody>
                                <tr style={{ background: "#c9e3ef" }}>
                                    <th>Montag</th>
                                    <td>9:30–10:15 Uhr,&nbsp;&nbsp;&nbsp;11:45–13:30 Uhr</td>
                                </tr>
                                <tr style={{ background: "#c9e3ef" }}>
                                    <th>Dienstag</th>
                                    <td>9:30-10:15 Uhr,&nbsp;&nbsp;&nbsp;11:45-12:00 Uhr</td>
                                </tr>
                                <tr style={{ background: "#c9e3ef" }}>
                                    <th>Mittwoch</th>
                                    <td>GESCHLOSSEN</td>
                                </tr>
                                <tr style={{ background: "#c9e3ef" }}>
                                    <th>Donnerstag</th>
                                    <td>9:30–12:00 Uhr,&nbsp;&nbsp;&nbsp;12:45–13:30 Uhr</td>
                                </tr>
                                <tr style={{ background: "#c9e3ef" }}>
                                    <th>Freitag</th>
                                    <td>9:30–10:15 Uhr,&nbsp;&nbsp;&nbsp;11:45–12:00 Uhr</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                   <div style={{ backgroundColor: "#2d70b9" }}>
                     <div className={styles.darkBackground + " wrapper wrapperContent"}>

                       <div className={styles.infoRow}>

                         <div className={styles.itext}>
                           <h3>Liebe Schülerinnen und Schüler,</h3>

                           <p>
                             bitte beachtet, dass die Schulbibliothek nur in der
                             1. und 2. Pause für euch geöffnet ist.
                           </p>

                           <p>Bibliothekarin: Frau Nguyen</p>

                           <p>E-Mail: d.nguyen@iks-schule.de</p>
                         </div>

                         <img
                           src={require("./assets/school.png")}
                           alt="Bibliothek Icon"
                           className={styles.icon}
                         />

                       </div>

                     </div>
                   </div>


            </div>
        </div>
    );
};

export default Bibliothek;
